import React,{useState} from 'react';
import { Container,Row } from 'react-bootstrap';
import { ContentHeader } from '../../Components/Components';
import { TabNavigation } from '../../Components/TabNavigation/TabNavigation';

export const Dashboard = ({state,updateState,loadData}) => {

  const { data,viewTab,loadingData,openMenu } = state;
  const currentYear = new Date().getFullYear();
  const beforeYear = new Date(new Date().setFullYear(new Date().getFullYear() - 1)).getFullYear();
  const {
    totalCobranzaCurrent       = 0,
    totalCobranzaBefore        = 0,
    totalProduccionCurrent     = 0,
    totalProduccionBefore      = 0,
    totalSiniestralidadCurrent = 0,
    totalSiniestralidadBefore  = 0,
    ventasMonthCurrent         = [],
    ventasYearCurrent          = [],
    ventasYearBefore           = [],
    ventasLast12Months         = [],
    siniestralidadMonthCurrent = [],
    siniestralidaLast12Months  = [],
  } = data[viewTab];
  const [dataTab, setDataTab] = useState([
    {
      name: 'Dirección',
      onClick: (e) => {
        updateState({
          viewTab: 0,
        }, loadData(0))
      },
    },
    {
      name: 'OS',
      onClick: (e) => {
        updateState({
          viewTab: 1,
        }, loadData(1))
      },
    },
    {
      name: 'ODQ´S',
      onClick: (e) => {
        updateState({
          viewTab: 2,
        }, loadData(2))
      },
    },
  ]);

  return (
    <div className={`ws_content_wrapper ${(!openMenu) ? 'wrapper_close' : ''}`}>
      <div className="ws_content_header ws_pl_0 ws_pr_0 mb-5">
        <TabNavigation data={dataTab} />
        <Container fluid>
          <h1 className="ws_title_header">Mi Dashboard</h1>
          <Row>
            
          </Row>
        </Container>
      </div>
    </div>
  )
}
